function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { InspectionPlannerIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { DismissableMessage, Heading, Message, Separator, SeparatorLink } from '@domain-group/fe-co-allhomes-design-system';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { PropertyWalkthrough } from '../property-walkthrough/property-walkthrough';
import OpenTimes from './open-times';
import PrivateInspections from './private-inspections';
import OnlineInspections from './online-inspections';
import Auction from './auction';
import * as styles from './inspections-auctions.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var InspectionsAuctions = _ref => {
  var state = _ref.state,
    inspections = _ref.inspections,
    auction = _ref.auction,
    bookInspection = _ref.bookInspection,
    agentName = _ref.agentName,
    walkthroughs = _ref.walkthroughs,
    listing = _ref.listing,
    onRemoveFromPlanner = _ref.onRemoveFromPlanner,
    onCalendarDownload = _ref.onCalendarDownload,
    onSignUpClick = _ref.onSignUpClick,
    onLogInClick = _ref.onLogInClick,
    onBookHomepassInspectionClick = _ref.onBookHomepassInspectionClick,
    onContactAgentClick = _ref.onContactAgentClick,
    onVideoClick = _ref.onVideoClick,
    onVirtualTourClick = _ref.onVirtualTourClick,
    onRegisterForAuctionClick = _ref.onRegisterForAuctionClick,
    onOnlineAuctionInfoClick = _ref.onOnlineAuctionInfoClick,
    endpoints = _ref.endpoints,
    disableWalkthroughs = _ref.disableWalkthroughs;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var hasInspections = (inspections === null || inspections === void 0 ? void 0 : inspections.length) > 0;
  var hasBookingLink = !!(bookInspection !== null && bookInspection !== void 0 && bookInspection.provider);
  var hasWalkthroughs = !disableWalkthroughs && !!(walkthroughs !== null && walkthroughs !== void 0 && walkthroughs.video || walkthroughs !== null && walkthroughs !== void 0 && walkthroughs.virtualTour);
  var inspectionMessage = state.inspectionsMessage ? state.inspectionsMessage.split(/\n/g).map(line => ___EmotionJSX("span", null, line, ___EmotionJSX("br", null))) : null;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("section", {
    "aria-label": "inspections"
  }, ___EmotionJSX(Heading, {
    title: "Inspections"
  }), inspectionMessage && (state.inspectionsRestricted ? ___EmotionJSX(Message, {
    appearance: "warning",
    title: state.inspectionsHeading,
    multiLine: true,
    css: styles.message
  }, inspectionMessage) : ___EmotionJSX(DismissableMessage, {
    title: state.inspectionsHeading,
    multiLine: true,
    storageKey: "inspections-20200814" // Change this if the content of the message changes such that users that have dismissed it should see it again.
    ,
    css: styles.message
  }, inspectionMessage)), ___EmotionJSX(OpenTimes, {
    inspections: inspections,
    listing: listing,
    plannerPageUrl: getAbsoluteUrl(endpoints.plannerPageUrl),
    onRemoveFromPlanner: onRemoveFromPlanner,
    onCalendarDownload: onCalendarDownload,
    onSignUpClick: onSignUpClick,
    onLogInClick: onLogInClick
  }), hasInspections && ___EmotionJSX(SeparatorLink, {
    href: getAbsoluteUrl(endpoints.plannerPageUrl),
    css: styles.plannerLink,
    icon: InspectionPlannerIcon,
    label: "View my Inspection Planner",
    onClick: () => sendEvent('inspection-planner-link-click')
  }), (!hasInspections || hasBookingLink) && ___EmotionJSX(PrivateInspections, {
    bookInspection: bookInspection,
    agentName: agentName,
    onBookHomepassInspectionClick: onBookHomepassInspectionClick,
    onContactAgentClick: onContactAgentClick
  }), (hasInspections || hasBookingLink) && ___EmotionJSX(OnlineInspections, {
    onContactAgentClick: onContactAgentClick,
    agentName: agentName,
    hasBookingLink: hasBookingLink
  }), hasWalkthroughs && ___EmotionJSX(PropertyWalkthrough, _extends({}, walkthroughs, {
    onVideoClick: onVideoClick,
    onVirtualTourClick: onVirtualTourClick
  }))), auction && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Separator, {
    css: styles.separator
  }), ___EmotionJSX(Auction, {
    listing: listing,
    auction: auction,
    auctionsRestricted: state.auctionsRestricted,
    onRegisterForAuctionClick: onRegisterForAuctionClick,
    onOnlineAuctionInfoClick: onOnlineAuctionInfoClick
  })));
};
InspectionsAuctions.propTypes = {
  listing: PropTypes.shape({}).isRequired,
  state: PropTypes.shape({
    abbreviation: PropTypes.string,
    inspectionsRestricted: PropTypes.bool,
    auctionsRestricted: PropTypes.bool,
    inspectionsMessage: PropTypes.string,
    inspectionsHeading: PropTypes.string
  }),
  inspections: PropTypes.arrayOf(PropTypes.shape({
    startTime: PropTypes.string,
    endTime: PropTypes.string
  })),
  bookInspection: PropTypes.shape({
    url: PropTypes.string,
    provider: PropTypes.string
  }),
  agentName: PropTypes.string,
  walkthroughs: PropTypes.shape({
    video: PropTypes.string,
    virtualTour: PropTypes.string
  }),
  auction: PropTypes.shape({}),
  onRemoveFromPlanner: PropTypes.func,
  onCalendarDownload: PropTypes.func,
  onSignUpClick: PropTypes.func,
  onLogInClick: PropTypes.func,
  onBookHomepassInspectionClick: PropTypes.func,
  onContactAgentClick: PropTypes.func,
  onVideoClick: PropTypes.func,
  onVirtualTourClick: PropTypes.func,
  onOnlineAuctionInfoClick: PropTypes.func,
  onRegisterForAuctionClick: PropTypes.func,
  disableWalkthroughs: PropTypes.bool,
  endpoints: PropTypes.shape({
    plannerPageUrl: PropTypes.string
  })
};
InspectionsAuctions.defaultProps = {
  state: {
    abbreviation: 'ACT'
  },
  inspections: [],
  bookInspection: null,
  agentName: 'the agent',
  walkthroughs: {},
  auction: null,
  onRemoveFromPlanner: () => {},
  onCalendarDownload: () => {},
  onSignUpClick: () => {},
  onLogInClick: () => {},
  onBookHomepassInspectionClick: () => {},
  onContactAgentClick: () => {},
  onVideoClick: () => {},
  onVirtualTourClick: () => {},
  onOnlineAuctionInfoClick: () => {},
  onRegisterForAuctionClick: () => {},
  disableWalkthroughs: false,
  endpoints: {
    plannerPageUrl: '/inspection-planner',
    onlineAuctionInfoLink: 'https://www.allhomes.com.au/advice/how-do-online-auctions-work-944249/'
  }
};
export default withAllhomesContext('endpoints')(InspectionsAuctions);